export const Domains = {
    MARKETING_SOLUTIONS: 'marketing_solutions',
    DEVELOPMENT_AND_PROGRAMMING: 'development_and_programming',
    ANY_OTHER_NEED: 'any_other_need',
    UNSPECIFIED: 'unspecified',
} as const;

export type DomainType = (typeof Domains)[keyof typeof Domains];
